import { IOptions } from '../shared/types';

export const defaultOptions: Partial<IOptions> = {
    debug: false,
};
